import { ComponentType } from '../../registries/types/propTypes';
import type { VideoBannerProps } from '../../../components/VideoBanner/VideoBanner';
import type { VideoModalData, ShopNow } from '../../../components/VideoBanner/types/propsTypes';
import { CMSTransformerDataType } from '../../types/common';
import transformVideoSection from '../video-section-transformer/video-section-transformer';
import { ImageDefination } from '../../../components/types/common';
const transformVideoBanner = (data: CMSTransformerDataType): VideoBannerProps => {
  const videoBannerData = Array.isArray(data?.video_banner) ? data?.video_banner[0] : data?.video_banner;
  const images: ImageDefination[] = videoBannerData?.background_image?.images?.map((item: CMSTransformerDataType) => {
    const image = {
      url: item.image.url,
      altText: item.alt_text,
      viewport: item.viewport,
    };
    return image;
  });

  const videoModalData: VideoModalData = {
    videoSection: transformVideoSection(videoBannerData),
  };
  const brandLogo: ImageDefination[] = videoBannerData?.logo?.images?.map((item: CMSTransformerDataType) => {
    const logoDetail = {
      url: item.image.url,
      altText: item.alt_text,
      viewport: item.viewport,
    };
    return logoDetail;
  });

  const overlayGradient = videoBannerData?.overlay_gradient;
  const linearGradient = videoBannerData?.linear_gradient?.color;
  const shopNow: ShopNow = {
    text: videoBannerData?.shop?.text,
    url: videoBannerData?.shop?.url,
    target: videoBannerData?.shop?.target,
  };
  const brandTagLine = videoBannerData?.description ?? '';
  const watchVideoText = videoBannerData?.watch?.label ?? '';
  const backgroundVideoUrl = videoBannerData?.background_video?.url ?? '';
  return {
    componentType: ComponentType.video_banner,
    images,
    brandLogo,
    overlayGradient,
    linearGradient,
    shopNow,
    brandTagLine,
    videoModalData: videoModalData,
    watchVideoText,
    backgroundVideoUrl,
  };
};

export default transformVideoBanner;
